/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

/* eslint-disable no-underscore-dangle */
class MeddreamWindows {
  private _meddreamWindow: Window | null = null;

  private _alive = false;

  public timer = null;

  public _windowClosed = true;

  private _clear = false;

  private _isEmptyWindow = false;

  checkCloseAfterOpen() {
    if (this.meddreamWindow?.closed) {
      this._windowClosed = true;
      this.stopTimer();
    }
  }

  private startTimer() {
    this.stopTimer();
    // @ts-ignore
    this.timer = setInterval(() => {
      this.checkCloseAfterOpen();
    }, 1000);
  }

  private stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  get meddreamWindow(): Window {
    return <Window>this._meddreamWindow;
  }

  set meddreamWindow(value: Window | null) {
    this._meddreamWindow = value;
    this._windowClosed = false;
    // Restart timer for each new window so closed-state tracking stays accurate
    if (value) {
      this.startTimer();
    } else {
      this.stopTimer();
    }
  }

  get alive(): boolean {
    return this._alive;
  }

  set alive(value: boolean) {
    this._alive = value;
  }

  get clear(): boolean {
    return this._clear;
  }

  set clear(value: boolean) {
    this._clear = value;
  }

  get closed(): boolean {
    return this._windowClosed;
  }

  set isEmptyWindow(value: boolean) {
    this._isEmptyWindow = value;
  }

  get isEmptyWindow(): boolean {
    return this._isEmptyWindow;
  }
}

const meddreamWindow = new MeddreamWindows();

export default meddreamWindow;
